import { render, staticRenderFns } from "./PolicyPenaltyPopup.vue?vue&type=template&id=358196b6"
import script from "./PolicyPenaltyPopup.vue?vue&type=script&lang=js"
export * from "./PolicyPenaltyPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports